import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách danh mục lãnh đạo theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách danh mục lãnh đạo
 */
export const getLeaderCategoriesByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.LEADER_CATEGORIES.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        }

        return [];
    } catch (error) {
        console.error(`[LeaderCategories] Lỗi khi lấy danh mục (lang=${languageCode}):`, error?.response?.status, error?.response?.data || error?.message);
        throw error;
    }
};

/**
 * Lấy danh sách sơ đồ tổ chức theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách sơ đồ tổ chức
 */
export const getOrganizationCharts = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.ORGANIZATION_CHARTS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        }

        return [];
    } catch (error) {
        console.error(`[OrganizationCharts] Lỗi khi lấy sơ đồ tổ chức (lang=${languageCode}):`, error?.response?.status, error?.response?.data || error?.message);
        throw error;
    }
};
